/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formattachment_Label1Inputs */

const ja_contact_formattachment_label1 = /** @type {(inputs: Contact_Formattachment_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添付ファイル (pdf, jpg, gif, png)`)
};

const en_contact_formattachment_label1 = /** @type {(inputs: Contact_Formattachment_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach a file (pdf, jpg, gif, png)`)
};

/**
* | output |
* | --- |
* | "Attach a file (pdf, jpg, gif, png)" |
*
* @param {Contact_Formattachment_Label1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formattachment_label1 = /** @type {((inputs?: Contact_Formattachment_Label1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formattachment_Label1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formattachment_label1(inputs)
	return en_contact_formattachment_label1(inputs)
});
export { contact_formattachment_label1 as "contact_formAttachment_label" }